import { CSSProperties } from 'react';
import { SELECTED_LABEL_FILTER_STRING } from 'components/Map/AreaMarker/constants';

export function getIconStyle(selected: boolean): CSSProperties {
  return {
    height: '21px',
    position: 'absolute',
    top: '8px', // Account for container padding
    filter: (selected) ? SELECTED_LABEL_FILTER_STRING : undefined,
    zIndex: 5,
  }
}